export const INTERFACE_MODE_STORAGE_KEY = 'payearth_interface_mode';

export const INTERFACE_MODES = {
    BUYER: 'buyer',
    SELLER: 'seller',
};

/**
 * Returns the user's explicit interface preference, or null when none is stored.
 * A missing key is not treated as buyer preference.
 */
export function readStoredInterfacePreference() {
    try {
        const stored = localStorage.getItem(INTERFACE_MODE_STORAGE_KEY);
        if (stored === INTERFACE_MODES.BUYER || stored === INTERFACE_MODES.SELLER) {
            return stored;
        }
    } catch (err) {
        // localStorage may be unavailable in private mode or SSR-like contexts
    }
    return null;
}

export function writeStoredInterfaceMode(mode) {
    try {
        localStorage.setItem(INTERFACE_MODE_STORAGE_KEY, mode);
    } catch (err) {
        // ignore write failures
    }
}

function readAuthStateFromStorage() {
    try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        return {
            isLoggedIn: userInfo !== null,
            userInfo: userInfo !== null ? userInfo : null,
        };
    } catch (err) {
        return { isLoggedIn: false, userInfo: null };
    }
}

/**
 * Infers interface mode from the current authenticated session when no preference exists.
 */
export function inferInterfaceModeFromAuth({ isLoggedIn, userInfo }) {
    if (isLoggedIn && userInfo && userInfo.role === 'seller') {
        return INTERFACE_MODES.SELLER;
    }
    return INTERFACE_MODES.BUYER;
}

/**
 * Stored preference takes precedence; otherwise infer from session.
 */
export function resolveEffectiveInterfaceMode(authState) {
    const storedPreference = readStoredInterfacePreference();
    if (storedPreference !== null) {
        return storedPreference;
    }
    return inferInterfaceModeFromAuth(authState);
}

/**
 * Resolves initial Redux interface mode using the same preference/inference rules as boot.
 */
export function resolveInitialInterfaceMode() {
    return resolveEffectiveInterfaceMode(readAuthStateFromStorage());
}
